// extracted by mini-css-extract-plugin
export default {"tabPanel":"Roles_tabPanel__3rZxs","chipLabel":"Roles_chipLabel__9cI7a"};